import { render, staticRenderFns } from "./Create-Or-Update-Preventive.vue?vue&type=template&id=4d99d9ee&scoped=true"
import script from "./Create-Or-Update-Preventive.vue?vue&type=script&lang=js"
export * from "./Create-Or-Update-Preventive.vue?vue&type=script&lang=js"
import style0 from "./Create-Or-Update-Preventive.vue?vue&type=style&index=0&id=4d99d9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d99d9ee",
  null
  
)

export default component.exports